<template>
	<nav
		class="navbar navbar-expand-lg navbar-absolute"
		:class="{ 'bg-white': showMenu, 'navbar-transparent': !showMenu }"
	>
		<div class="container-fluid">
			<div class="navbar-wrapper">
				<div class="navbar-minimize d-inline" style="margin-top: -20px;">
					<sidebar-toggle-button />
				</div>
				<div class="navbar-toggle d-inline">
					<button type="button" class="navbar-toggler" @click="toggleSidebar">
						<span class="navbar-toggler-bar bar1"></span>
						<span class="navbar-toggler-bar bar2"></span>
						<span class="navbar-toggler-bar bar3"></span>
					</button>
				</div>
				<a class="navbar-brand" href="javascript:void(0)">
					<img
						style="margin-top: -20px;"
						width="150"
						src="img/edp_logo.png"
						alt=""
				/></a>
			</div>
			<div
				class="collapse navbar-collapse show text-left"
				v-show="showMenu"
			></div>
			<h4 class="text-right">
				Olá, tem
				<span style="color:#212e3e">
					<b>
						<u>{{ pontos }} pontos!</u>
					</b></span
				>
			</h4>
		</div>
	</nav>
</template>
<script>
	import DropDown from "@/components/Dropdown.vue";
	import Modal from "@/components/Modal.vue";
	import SidebarToggleButton from "./SidebarToggleButton.vue";
	import api from "@/api/index";

	export default {
		components: {
			DropDown,
			Modal,
			SidebarToggleButton,
		},
		data() {
			return {
				searchModalVisible: false,
				searchQuery: "",
				showMenu: false,
				pontos: 0,
				utilizador: [],
			};
		},
		methods: {
			toggleSidebar() {
				this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
			},
			toggleMenu() {
				this.showMenu = !this.showMenu;
			},
		},
		async mounted() {
			var user_id = localStorage.getItem("active-session-niu");
			var jsonUser = {
				user_id: user_id,
			};
			let res = await api.buscarDados(jsonUser);
			if (Object.values(res).length > 0) {
				this.utilizador = Object.values(res)[0];
				this.utilizadores = Object.values(res);
			}
			for (let i = 0; i < this.utilizadores.length; i++) {
				this.utilizadores[i].pontosFinais = 0;
				var temp = [];
				var pontos = [];
				if (this.utilizadores[i].pontos != null) {
					pontos = this.utilizadores[i].pontos;
				}

				if (this.utilizadores[i].grupo == "1" && pontos.length > 0) {
					temp = Object.values(JSON.parse(pontos));
					Object.keys(temp).map((j) => {
						this.utilizadores[i].pontosFinais += Number(temp[j].pontos);
						this.pontos += Number(temp[j].pontos);
					});
				}
				if (this.utilizadores[i].grupo == "2" && pontos.length > 0) {
					temp = Object.values(JSON.parse(pontos));
					Object.keys(temp).map((j) => {
						this.utilizadores[i].pontosFinais += Number(temp[j].pontos);
						this.pontos += Number(temp[j].pontos);
					});
				}
			}
		},
		computed: {
			isRTL() {
				return this.$rtl.isRTL;
			},
		},
	};
</script>
<style></style>
